import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#00AC3A",
      d: "M13.83 5.457a1.362 1.362 0 1 1 2.037 1.812l-6.465 7.275a1.363 1.363 0 0 1-2.038 0l-3.232-3.638 1.018-.905 1.019-.908 2.214 2.49zM4.245 8.98a1.364 1.364 0 0 1 1.924.113l-2.037 1.813c-.5-.563-.45-1.426.113-1.926",
      style: {"fill":"var(--global-green-primary)"}
    }, null, -1),
    _createElementVNode("path", {
      stroke: "#fff",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-opacity": ".9",
      "stroke-width": "1.637",
      d: "M13.218 4.914a2.181 2.181 0 0 1 3.4 2.724l-.14.174-6.464 7.276h-.001a2.18 2.18 0 0 1-3.096.165l-.164-.165L3.52 11.45c-.8-.9-.72-2.281.18-3.082l.175-.14a2.183 2.183 0 0 1 2.904.32v.002l1.603 1.801z",
      style: {"stroke":"#fff","stroke-opacity":".9"}
    }, null, -1)
  ])))
}
export default { render: render }